import React from "react";
import { useQuery } from "react-query";
import { LoadingDots, Select } from "web-ui";

import { getMajorMinorVersions } from "api/dashboardBackend";
import styles from "components/common/VersionSelect.module.scss";
import { type PlatformId } from "util/platform";

interface Props {
  onChangeCallback: (value: string) => void;
  platformId: PlatformId;
  queryPrompt: string;
  value: string;
}

const VersionSelect = ({
  onChangeCallback,
  platformId,
  queryPrompt,
  value,
}: Props) => {
  const { data, error, isLoading } = useQuery({
    queryFn: () => getMajorMinorVersions(platformId),
    queryKey: [platformId, "version-select"],
  });

  return data && data.length > 0 ? (
    <div>
      <span className={styles.queryText}>{queryPrompt}</span>
      <Select
        className={styles.select}
        onChange={e => onChangeCallback(e.target.value)}
        options={data.map(version => ({
          text: `${version.major}.${version.minor}`,
          value: `${version.major}.${version.minor}`,
        }))}
        value={value}
      />
    </div>
  ) : isLoading ? (
    <LoadingDots type="screen-white" />
  ) : (
    <>
      {`Error fetching ${queryPrompt}: ${error}`}
      <br />
    </>
  );
};

export default VersionSelect;
